var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.allFields)?_c('form',{attrs:{"method":"post","action":_vm.actionUrl}},[_c('input',{attrs:{"type":"hidden","name":"PaReq"},domProps:{"value":_vm.pareq}}),_c('input',{attrs:{"type":"hidden","name":"TermUrl"},domProps:{"value":_vm.termUrl}}),_c('input',{attrs:{"type":"hidden","name":"MD"},domProps:{"value":_vm.md}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }